module.exports = "<nv-react-component component=\"CourseMenteesPanel\"></nv-react-component>";